import { motion } from 'framer-motion'

const stats = [
  {
    value: '+150%',
    label: 'Látogatottság növekedés',
    description: 'átlagosan az első 3 hónapban',
  },
  {
    value: '3x',
    label: 'Több érdeklődő',
    description: 'a korábbi eredményekhez képest',
  },
  {
    value: '50+',
    label: 'Elégedett ügyfél',
    description: 'kis- és középvállalkozás',
  },
  {
    value: '95%',
    label: 'Ügyfél elégedettség',
    description: 'visszatérő ügyfelek aránya',
  },
]

const testimonials = [
  {
    quote: 'Végre valaki, aki érti a kisvállalkozások problémáit. A weboldalunk forgalma megháromszorozódott!',
    author: 'Kovács Péter',
    role: 'Ügyvezető, TechStart Kft.',
  },
  {
    quote: 'Krisztina segítségével végre értjük, mit csinálunk a marketingben. Az eredmények önmagukért beszélnek.',
    author: 'Nagy Anna',
    role: 'Tulajdonos, BioKert Webshop',
  },
]

const Results = () => {
  return (
    <section id="eredmenyek" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center max-w-3xl mx-auto mb-16 md:mb-20">
          <motion.span
            className="text-coffee-600 text-sm font-medium tracking-widest uppercase block mb-4"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            Eredmények
          </motion.span>
          <motion.h2
            className="font-heading text-4xl md:text-5xl font-bold text-coffee-900 mb-6"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            Számok, amik beszélnek
          </motion.h2>
          <motion.p
            className="text-lg text-coffee-600 leading-relaxed"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            Az ügyfeleim sikere az én sikerem. Íme néhány eredmény a közös munkánkból.
          </motion.p>
        </div>

        {/* Stats grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mb-20">
          {stats.map((stat, index) => (
            <motion.div
              key={stat.label}
              className="bg-white rounded-2xl p-6 md:p-8 text-center border border-coffee-100"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <motion.span
                className="block font-heading text-4xl md:text-5xl font-bold text-coffee-900 mb-2"
                initial={{ scale: 0.5 }}
                whileInView={{ scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 + 0.2 }}
              >
                {stat.value}
              </motion.span>
              <span className="block font-semibold text-coffee-800 mb-1">
                {stat.label}
              </span>
              <span className="text-sm text-coffee-500">
                {stat.description}
              </span>
            </motion.div>
          ))}
        </div>

        {/* Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.author}
              className="bg-coffee-900 text-cream rounded-2xl p-8 md:p-10"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.15 }}
            >
              {/* Quote mark */}
              <div className="text-6xl font-heading text-coffee-600 leading-none mb-4">
                "
              </div>
              <p className="text-lg md:text-xl leading-relaxed mb-6">
                {testimonial.quote}
              </p>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-coffee-700 rounded-full flex items-center justify-center text-xl">
                  {testimonial.author.charAt(0)}
                </div>
                <div>
                  <p className="font-semibold">{testimonial.author}</p>
                  <p className="text-coffee-300 text-sm">{testimonial.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Results
